let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1AK05")).then(() => parcelRequire('gg3ZI'));